// wishlistReducer.js
const wishlistReducer = (state, action) => {
  switch (action.type) {
    case 'get_wl':
      return { ...state, items: action?.payload ?? {} };

    case 'add_wl': {
      const item = action.payload;
      return {
        ...state,
        items: { ...state.items, [item?.sku]: item },
      };
    }

    case 'remove_wl': {
      const newItems = { ...state.items };
      delete newItems[action.payload];
      return {
        ...state,
        items: newItems,
        itemsCount: state?.itemsCount ? state?.itemsCount - 1 : null,
      };
    }

    case 'set_loading':
      return { ...state, loading: !!action.payload };

    case 'set_error':
      return { ...state, error: action.payload ?? null };

    case 'sync_from_api':
      return {
        ...state,
        items: action.payload?.items ?? state.items,
        itemsCount: action.payload?.itemsCount ?? state.itemsCount,
        error: null,
      };

    case 'set_items_count':
      return { ...state, itemsCount: action.payload };

    default:
      return state;
  }
};

export default wishlistReducer;
